import {
  LOAD_VIDEO_URL,
  SET_VIDEO_CONTROL,
  UPDATE_VIDEO_TIME,
  CLEAR_VIDEO_URL,
  SET_CURRENT_ACTION,
  SET_FULL_ANALYSE_STRING,
  CLEAR_CURRENT_ACTION,
  CLEAR_FULL_ANALYSE_STRING,
  UPDATE_ACTION_LOG,
  CLEAR_ACTION_LOG,
  CONTROLLER_TOGGLE,
  VIDEO_SEEK_TIME,
  CLEAR_SEEK_FLAG,
  PUSH_MATCH_STRING_SERVER_SUCCESS,
  PUSH_MATCH_STRING_SERVER_FAILED,
  FETCH_MATCH_STRING_SERVER_SUCCESS,
  FETCH_MATCH_STRING_SERVER_FAILED,
} from "./types";
import axios from "axios";
import { SSENSE_URL } from "../../config/stepoutAPI";
import { trackEvent, getLastEventString } from "../../utils/mixpanel";

export const UpdateVideoTime = (time) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_VIDEO_TIME, payload: time });
  };
};

export const SeekVideoTo = (time) => {
  return { type: VIDEO_SEEK_TIME, payload: time };
};

export const ClearSeekFlag = () => {
  return { type: CLEAR_SEEK_FLAG };
};

export const SetVideoControl = (c) => {
  return { type: SET_VIDEO_CONTROL, payload: c };
};

export const LoadVideoUrl = (url) => {
  return { type: LOAD_VIDEO_URL, payload: url };
};

export const ClearVideoUrl = () => {
  return { type: CLEAR_VIDEO_URL };
};

export const SetCurrentAction = (action) => {
  return { type: SET_CURRENT_ACTION, payload: action };
};

// `source` (optional) labels the change in Firestore commit history.
export const SetFullAnalyseString = ({ id, string, source }) => {
  return { type: SET_FULL_ANALYSE_STRING, payload: source ? { id, string, source } : { id, string } };
};

export const ClearCurrentAction = () => {
  return { type: CLEAR_CURRENT_ACTION };
};

export const ClearFullAnalyseString = () => {
  return { type: CLEAR_FULL_ANALYSE_STRING };
};

export const AddToActionLog = (action) => {
  return { type: UPDATE_ACTION_LOG, payload: action };
};

export const ClearActionLog = () => {
  return { type: CLEAR_ACTION_LOG };
};

export const SetControllerToggle = (val) => {
  return {
    type: CONTROLLER_TOGGLE,
    payload: val,
  };
};

export const PushMatchStringToServer = (
  match_id,
  analyst_id,
  string,
  token
) => {
  return (dispatch) => {
    // Mixpanel – track every push to the server with string metrics
    // const events = string
    //   ? string.split(',').filter((s) => s.trim() && s.trim() !== 'X-X-X-X-X-X-X-X-X-X-X-X-X-X')
    //   : [];
    // trackEvent().track('push_match_string_to_server', {
    //   match_id,
    //   string_event_count: events.length,
    //   string_char_length: string ? string.length : 0,
    // });

    const data = {
      match_id: match_id,
      analyst_id: analyst_id,
      match_string: string,
    };

    axios
      .post(`${SSENSE_URL}push_match_video_string/v2/`, data, {
        headers: {
          Authorization: "ANALYST " + token,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch({ type: PUSH_MATCH_STRING_SERVER_SUCCESS });
        } else {
          dispatch({ type: PUSH_MATCH_STRING_SERVER_FAILED });
        }
      })
      .catch((error) => {
        dispatch({ type: PUSH_MATCH_STRING_SERVER_FAILED });
      });
  };
};

// Resolves true when the server answered (even with no saved string) and false
// when the request failed, so callers can stop work on a stale local string.
export const FetchMatchStringFromServer = (match_id, analyst_id, token) => {
  return (dispatch) => {
    try {
      const data = {
        match_id: match_id,
        analyst_id: analyst_id,
      };
      // Mixpanel – API call initiated
      trackEvent().track('fetch_match_string_api_called', { match_id });
      return axios
        .post(`${SSENSE_URL}get_match_video_string/v2/`, data, {
          headers: {
            Authorization: "ANALYST " + token,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const data = response?.data;
            const str = data?.temp_string;
            if (str && str !== "") {
              // Mixpanel – success
              const eventCount = str
                .split(',')
                .filter((s) => s.trim() && s.trim() !== 'X-X-X-X-X-X-X-X-X-X-X-X' && s.trim() !== 'X-X-X-X-X-X-X-X-X-X-X-X-X-X')
                .length;
              const lastStr = getLastEventString(str);
              trackEvent().track('fetch_match_string_api_success', {
                match_id,
                string_event_count: eventCount,
                ...(lastStr ? { last_event_string: lastStr } : {}),
              });
              dispatch({
                type: FETCH_MATCH_STRING_SERVER_SUCCESS,
                payload: { id: match_id, string: str },
              });
            }
            return true;
          }
          dispatch({ type: FETCH_MATCH_STRING_SERVER_FAILED });
          return false;
        }, (error) => {
          // Network down or API error — only the request itself lands here.
          console.warn("[FetchMatchStringFromServer] failed:", error?.message);
          dispatch({ type: FETCH_MATCH_STRING_SERVER_FAILED });
          return false;
        });
    } catch (error) {
      dispatch({ type: FETCH_MATCH_STRING_SERVER_FAILED });
      return Promise.resolve(false);
    }
  };
};
